import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { trackPromise } from "react-promise-tracker";
import { toast } from "react-toastify";
import suppliesApi from "../../constants/suppliesApi";

const CreateModal = ({ open, hide, t, getData }) => {
  const [code, setCode] = useState("");
  const [currentKm, setCurrentKm] = useState(0);

  const createOdometer = () => {
    const body = {
      code,
      current_km: currentKm,
      customer: parseInt(localStorage.getItem("GlobalCustomerId")),
    };

    trackPromise(
      suppliesApi
        .createOdometer(body)
        .then((res) => {
          getData();
          hide();
          toast.success("Odometro creado");
        })
        .catch((err) => {
          toast.error(err.response.data.detail);
        })
    );
  };

  return (
    <Modal show={open} dialogClassName="modal-sm-providers" onHide={hide}>
      <Modal.Header closeButton>
        <Modal.Title>Crear odometro</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="form-group">
            <label htmlFor="dateInput">
              <span className="text-danger">*</span> Codigo
            </label>
            <input
              className="form-control"
              placeholder="Codigo"
              id="dateInput"
              name="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              type="text"
              required
            />
          </div>
          <div className="form-group">
            <label>Kilometraje Inicial</label>
            <input
              type="number"
              className="form-control"
              name="current_km"
              value={currentKm}
              onChange={(e) => setCurrentKm(Number(e.target.value))}
              placeholder="Kilometraje"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-outline-primary" onClick={hide}>
          Cancelar
        </button>
        <button
          className="btn btn-primary"
          onClick={() => createOdometer()}
          disabled={code.length ? false : true}
        >
          Registrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateModal;
